import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AutocompleteComponent } from './autocomplete.component';
import {AutocompleteLibModule} from 'angular-ng-autocomplete'; //https://www.npmjs.com/package/angular-ng-autocomplete?activeTab=readme

@NgModule({
  declarations: [AutocompleteComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AutocompleteLibModule
  ],
  exports: [AutocompleteComponent]
})
export class AutocompleteModule { }
